import { setEditShippingAddress, setEditShippingMethod, setEditPaymentMethod, setValidateAddressDrawerState, setOpenValidateAddressDrawer, } from "Root/checkout/redux/slices/checkoutComponentSlice";
import { createPaymentIntent, fetchPricing } from "Root/checkout/redux/slices/checkoutPricingSlice";
import { fetchShippingAddress, fetchShippingData, submitShippingAddress, updateShippingInfo, } from "Root/checkout/redux/slices/checkoutShippingSlice";
import { setGlobalLoading } from "Root/profile/redux/actionCreators/makeActionCreator";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
const useCheckoutConfirmShipping = (isFetchData = true) => {
    const data = useSelector((state) => state.checkoutShipping.address);
    const isOtb = useSelector((state) => state.checkoutPricing.plan === "otb");
    const shippingMethodsData = useSelector((state) => state.checkoutShipping.shippingMethodsData);
    const isLoadingShippingMethods = useSelector((state) => state.checkoutShipping.isLoadingShippingMethods);
    const ref = useRef(null);
    const componentState = useSelector((state) => state.checkoutComponent);
    const isMobile = useScreenWidth() < 968;
    const dispatch = useDispatch();
    const openDrawer = componentState.openValidateAddressDrawer;
    const drawerState = componentState.validateAddressDrawerState;
    const { isInfluencer } = componentState;
    const cautiousAddress = useSelector((state) => state.checkoutShipping.cautiousAddress);
    const setDrawerState = (value) => {
        dispatch(setValidateAddressDrawerState(value));
    };
    const setOpenDrawer = (value) => {
        dispatch(setOpenValidateAddressDrawer(value));
    };
    const handleChange = async (value, name) => {
        dispatch(updateShippingInfo({ value, name }));
        if (name === "shipping_method") {
            dispatch(setGlobalLoading(true));
            dispatch(updateShippingInfo({ value: value.toLowerCase(), name }));
            await dispatch(fetchPricing(value));
            dispatch(setGlobalLoading(false));
        }
    };
    const goToShippingMethod = () => {
        dispatch(setEditShippingAddress(false));
        dispatch(setEditShippingMethod(true));
    };
    const goToPaymentMethod = () => {
        if (isInfluencer) {
            dispatch(setEditPaymentMethod(false));
            dispatch(setEditShippingAddress(false));
            dispatch(setEditShippingMethod(false));
        }
        else {
            dispatch(setEditPaymentMethod(true));
            dispatch(setEditShippingAddress(false));
            dispatch(setEditShippingMethod(false));
            dispatch(createPaymentIntent({ shippingSpeed: data.shipping_method, isOtb: isOtb }));
        }
    };
    const toggleDrawer = (value) => () => {
        if (!value) {
            setDrawerState({
                invalid: false,
                changed: false,
            });
        }
        setOpenDrawer(value);
    };
    const getShippingMethodData = (shippingMethod) => {
        return shippingMethodsData.shipping_methods.find((item) => item.name.toLowerCase() === shippingMethod.toLowerCase());
    };
    const getPropsForReviewBox = () => {
        return {
            onEdit: () => {
                dispatch(setEditShippingAddress(true));
                dispatch(setEditShippingMethod(false));
                dispatch(setEditPaymentMethod(false));
                if (ref.current) {
                    window.scrollTo(0, ref.current.offsetTop);
                }
            },
            data: [
                {
                    title: "Shipping Address",
                    text: [
                        `${data.firstName} ${data.lastName}`,
                        `${data.street}`,
                        `${data.apartment || ""}`,
                        `${data.city}, ${data.state} ${data.zip}`,
                    ],
                },
                !componentState.isEditShippingMethod && !componentState.isEditShippingAddress
                    ? {
                        title: "Shipping Method",
                        text: [
                            data.shipping_method === "standard" ? "Standard Shipping" : "Expedited Shipping",
                            `Arrives ` + getShippingMethodData(data.shipping_method)?.approximateDeliveryTime?.join(" - "),
                        ],
                    }
                    : {
                        title: "",
                        text: [],
                    },
            ],
        };
    };
    const validateAddress = Object.keys(data)
        .filter((item) => item !== "apartment")
        .some((key) => !data[key]);
    const submitAddress = async (verify = true, oldAddress = false, providedAddress = null) => {
        let address = data;
        if (oldAddress) {
            address = cautiousAddress;
        }
        else if (providedAddress) {
            address = providedAddress;
        }
        await dispatch(submitShippingAddress({ body: address, verify }));
    };
    const verifyAddress = () => {
        toggleDrawer(false)();
        submitAddress(false);
    };
    const acceptNewAddress = () => {
        toggleDrawer(false)();
        submitAddress(false, true);
    };
    const acceptOldAddress = () => {
        toggleDrawer(false)();
        submitAddress(false, false);
    };
    const fetchData = () => {
        if (!isFetchData)
            return;
        dispatch(fetchShippingAddress());
        dispatch(fetchShippingData());
    };
    const shippingMethods = shippingMethodsData.shipping_methods.filter((item) => {
        if (isInfluencer) {
            return item.name.toLowerCase() === "standard";
        }
        else {
            return true;
        }
    });
    useEffect(() => {
        fetchData();
    }, []);
    return {
        data,
        handleChange,
        goToShippingMethod,
        goToPaymentMethod,
        getPropsForReviewBox,
        validateAddress,
        componentState,
        openDrawer,
        toggleDrawer,
        isMobile,
        drawerState,
        cautiousAddress,
        submitAddress,
        verifyAddress,
        acceptOldAddress,
        acceptNewAddress,
        shippingMethodsData,
        isLoadingShippingMethods,
        ref,
        isInfluencer,
        shippingMethods,
    };
};
export default useCheckoutConfirmShipping;
